class UserSession {
  id() {
    const userSessionId = JSON.parse(
      window.localStorage.getItem('_pd_secure_session_token')
    );
    return userSessionId;
  }

  set(id) {
    window.localStorage.setItem('_pd_secure_session_token', JSON.stringify(id));
  }
}

export default UserSession;
